<script>
    import { expandSection, collapseSection } from './toggleHelpers.js'
    export let data

    const toggleExample = (event, id) => {
        console.log(event.currentTarget)

        const toggleElement = event.currentTarget.nextElementSibling
        
        console.log(toggleElement)

        data.examples[id].isExpanded
        ? collapseSection(toggleElement)
        : expandSection(toggleElement)

        data.examples[id].isExpanded = !data.examples[id].isExpanded
    } 
</script>

<style>
.Card {
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
}

h2 {
    font-size: 20px;
    font-family: var(--font-heading);
    font-weight: normal;
    margin: 7.5px 0px;
    padding-bottom: 7.5px;
    border-bottom: 1px solid var(--colour-secondary);
}

p {
    margin: 15px 0;
}

.section {
    margin: 0 0 15px 0;
}

table {
    margin: 0px 15px 15px 0px;
    border-spacing: 10px 5px;
    border-collapse: collapse;
    width: 100%;
}

th {
    text-align: left;
    padding: 0;
}

tr:nth-child(even) {
    background-color: var(--colour-secondary-l);
}

td {
    vertical-align: top;
    padding: 0;
    min-width: 50px;
}

.example .title {
    cursor: pointer;
    margin-bottom: 0px;
    -webkit-user-select: none;  /* Chrome all / Safari all */
    -moz-user-select: none;     /* Firefox all */
    -ms-user-select: none;      /* IE 10+ */
    user-select: none;
}

.tags {
    display: flex;
    flex-wrap: wrap;
}

.tag {
    /* background-color: var(--colour-secondary); */
    padding: 5px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    white-space: nowrap;
    border-radius: 20px;
    border: solid 1px var(--colour-secondary);
}

.expandable {
    overflow:hidden;
    transition:height 0.3s ease-out;
    height:auto;
    margin-top: 0px;
}

.arrow {
    --arrow-size: 6px;
    display: inline-block;
    height: 0;
    width: 0;
    border-top: transparent solid var(--arrow-size);
    border-bottom: transparent solid var(--arrow-size);
    border-left: var(--colour-secondary-l) solid var(--arrow-size);
    margin-right: 5px;
    transition: 0.2s;
    transition-property: transform;
}

.arrow.expanded {
    transform: rotate(90deg);
}

</style>

<div class="Card">
    <h2>{data.title}</h2>
    <p class="section">{data.description}</p>
    {#if data.lines && data.lines.length}
        <table>
            {#each data.lines as line}
                <tr>
                    {#each line as column}
                        <td>{column}</td>
                    {/each}
                </tr>
            {/each}
        </table>
    {/if}
    {#if data.examples && data.examples.length}
        {#each data.examples as example, index}
            <div class="example">
                <p class="title" on:click={(event) => toggleExample(event, index)}>
                    <span class={
                        example.isExpanded
                        ? 'arrow expanded'
                        : 'arrow collapsed'
                    }></span>
                    <b>{example.title}</b>, {example.author}
                </p>
                <p class="text expandable" style="height: 0px;" data-collapsed="true">
                    <br/>{@html example.textAsHtml}
                </p>
            </div>
        {/each}
    {/if}
    {#if data.tags && data.tags.length}
        <div class="tags">
            {#each data.tags as tag}
                <div class="tag">{tag}</div>
            {/each}
        </div>
    {/if}
</div>
